module.exports = __webpack_public_path__ + "img/Logo_double_row_blue@3x.8680198f.png";